<div class="pagination-container" *ngIf="pagination && pagination.length > 1">
  <div class="pagination">
    <span
      *ngIf="ready && !WindowHelper.isMobile"
      class="pagination__tab pagination__link prev"
      [ngClass]="{'hidden': currentPage - visiblePagesRange <= 1}"
      (click)="paginationClick(1, currentPage - visiblePagesRange > 1)"
    >
        1
    </span>

    <span
      class="pagination__tab prev"
      [ngClass]="{'hidden': !paginationLinkPrev}"
      (click)="paginationClick(currentPage - 1, paginationLinkPrev)"
    >
      <
    </span>

    <span class="tabs">
      <span
        class="pagination__tab"
        *ngFor="let page of pagination"
        [ngClass]="{
          'active': page === currentPage,
          'hidden': !(page <= currentPage + visiblePagesRange && page >= currentPage - visiblePagesRange)
        }"
        (click)="paginationClick(page, page <= currentPage + visiblePagesRange && page >= currentPage - visiblePagesRange)"
      >
        {{ page }}
      </span>
    </span>

    <span
      class="pagination__tab next"
      [ngClass]="{'hidden': !paginationLinkNext}"
      (click)="paginationClick(currentPage + 1, paginationLinkNext)"
    >
      >
    </span>

    <span
      *ngIf="ready && !WindowHelper.isMobile"
      class="pagination__tab pagination__link next"
      [ngClass]="{'hidden': currentPage + visiblePagesRange >= pagination.length}"
      (click)="paginationClick(pagination.length, currentPage + visiblePagesRange < pagination.length)"
    >
     {{ pagination.length }}
    </span>
  </div>

  <div class="total-items">

    <span class="summary">
      {{ currentItemsCountFrom }}
       -
      {{ currentItemsCountTo }} of {{ totalCount }} results
    </span>

  </div>
</div>
